import { render } from "./basic-statistics.vue?vue&type=template&id=2a6b6dc8"
import script from "./basic-statistics.vue?vue&type=script&lang=js"
export * from "./basic-statistics.vue?vue&type=script&lang=js"

import exportComponent from "D:\\repos\\rivendom-compendium\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__